
const prepareShow = bike => {
  bike.price = bike.price
  return bike
}

const prepareSearch = (search) => {
  search.generic = search.generic
  return search
}

export default {
  prepareShow,
  prepareSearch,
  doFilterSearch () {
    this.setPage(1)
  },
  doClearSearch () {
    this.search.generic = null
    this.doLoadAll()
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/bike/index/resources/methods.js